<template>
  <modal
    :show.sync="isOpenLocal"
    scrollable
    header-classes="bg-primary p-2 flex items-center"
    size="lg"
    @close="handleClose"
  >
    <!-- <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Add News
    </h6> -->

    <h6 class="modal-title text-black font-semibold">Edit Achievements</h6>

    <div class="d-flex h-28 mt-4">
      <img
        v-if="image"
        :src="image"
        ref="cover"
        class="object-fit w-2/4 h-28 mr-5 rounded"
      />

      <img
        v-else-if="file"
        :src="$imageURL + '/' + file"
        ref="cover"
        class="object-fit w-2/4 h-28 mr-5 rounded"
      />

      <!-- default image -->
      <img
        v-else
        src="@/assets/images/wgrid6.jpg"
        alt=""
        class="object-cover w-2/4 h-28 mr-5 rounded"
      />
      <FileUploader
        ref="FileUploader"
        v-show="true"
        :image="image"
        :onSuccess="handleSuccess"
        class="object-cover w-2/4 rounded profimage"
        style="height: auto"
      />
    </div>

    <div class="mt-2 md:flex">
      <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
        <p class="input-title-black">Course Name</p>
        <base-input
          v-model="cname"
          placeholder="Enter Course Name"
          name="Course Name"
          class="cust-form-border"
        ></base-input>

        <!-- <b-form-checkbox value="cred" size="sm"
            ><p>This credential does not expire</p></b-form-checkbox
          > -->
      </div>

      <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
        <p class="input-title-black">Author Name</p>
        <base-input
          name="Author Name"
          v-model="author"
          placeholder="Enter Author Name"
          class="cust-form-border"
        ></base-input>
      </div>
    </div>

    <div class="">
      <div class="w-full mt-6">
        <p class="input-title-black">Issued Date</p>
        <!-- <div class="md:flex"> -->
        <div class="ml-0 md:w-1/2 lg:w-1/2 w-full pt-4">
          <b-form-group>
            <date-picker
              required
              :config="{ allowInput: true }"
              placeholder="Select Date"
              v-model="issuedate"
              format="DD-MM-YYYY"
              class="formborder"
              valueType="format"
            />
          </b-form-group>
          <!-- </div> -->
          <!-- <div class="md:w-1/2 lg:w-1/2 md:pl-5 w-full pt-4">
              <b-form-select>
                v-model="issend" :options= "users" class="text-base text-black "
              </b-form-select>
            </div> -->
        </div>
      </div>
    </div>

    <div class="">
      <div class="mt-6 w-full">
        <p class="input-title-black">Expired Date</p>
        <div class="md:flex">
          <!-- <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
              <b-form-select>
                v-model="exp" :options= "users" class="text-base text-black"
              </b-form-select>
            </div> -->
          <div class="md:w-1/2 lg:w-1/2 w-full py-1 rounded">
            <b-form-group>
              <date-picker
                required
                :config="{ allowInput: true }"
                placeholder="Select Date"
                v-model="expiredate"
                format="DD-MM-YYYY"
                valueType="format"
                class="formborder"
              >
              </date-picker>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>

    <template slot="footer">
      <!-- <base-button type="primary" @click="addAchievement" :disabled="isdisabled"
        >GET</base-button
      > -->
      <base-button type="primary" @click="edit">SAVE CHANGES </base-button>
      <base-button type="secondary" class="ml-auto border" @click="handleClose"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import FileUploader from "@/components/FileUploader";
import coverImage from "./coverImage.vue";
import { mapState } from "vuex";
export default {
  components: {
    DatePicker,
    FileUploader,
    coverImage,
  },

  data() {
    return {
      image: null,
      myimage: null,
      file: null,
      cname: "",
      author: "",
      issuedate: "",
      expiredate: "",
      isdisabled: false,
      issued: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      issend: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      expend: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
      exp: [
        { value: null, text: "select Designation", disable: "true" },
        "Student",
        "Teacher",
      ],
    };
  },

  props: {
    isOpen: Boolean,
    data: { type: Object },
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("achievement", {
      edit_achievement: "edit_achievement",
    }),
    ...mapState("achievement", {
      ed_achievement: "ed_achievement",
    }),
    isOpenLocal: {
      get() {
        return this.isOpen;
      },
      set(val) {
        if (!val) {
          this.handleClose();
        }
      },
    },
    edituser: {
      get() {
        return this.data;
      },
    },
    magittUrl() {
      return this.$imageURL;
    },

    checking() {
      // console.log("checking");
    },
  },
  methods: {
    handleSuccess(image) {
      this.file = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    HandleDelete() {
      this.image = null;
      this.coverImage = null;
    },

    handleClose() {
      this.image = null;
      this.file = null;
      this.cname = "";
      this.author = "";
      this.issuedate = "";
      this.expiredate = "";
      this.$emit("close");
    },
    async getAchievementById() {
      const payload2 = {
        _id: this.edituser._id,
      };

      await this.$store.dispatch("achievement/getAchievementById", payload2);

      // console.log(this.edit_achievement[0].authorName);

      this.author = this.edit_achievement[0].authorName;
      this.cname = this.edit_achievement[0].courseName;
      this.expiredate = this.edit_achievement[0].expiredDate;
      this.issuedate = this.edit_achievement[0].issuedDate;
      this.file = this.edit_achievement[0].file;
    },
    async edit() {
      let FormData = require("form-data");
      let payload = new FormData();
      payload.append("courseName", this.cname);
      payload.append("authorName", this.author);
      payload.append("issuedDate", this.issuedate);
      payload.append("expiredDate", this.expiredate);
      payload.append("file", this.file);
      payload.append("userid", this.userData._id);
      payload.append("_id", this.edituser._id);

      const data = await this.$store.dispatch(
        "achievement/editAchievement",
        payload
      );

      if (data.code == 200) {
        this.$swal.fire({
          title: "Success!",
          text: "Your Achievement has been updated",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });

        this.image = null;
        this.file = null;
        this.cname = "";
        this.author = "";
        this.issuedate = "";
        this.expiredate = "";
        const payload2 = {
          userid: this.userData._id,
        };

        await this.$store.dispatch("achievement/getAchievement", payload2);
        this.handleClose();
      }
    },
  },

  //  async mounted() {
  //     // this.cname=this.edituser.cname

  //     // if(this.edit_achievement[0].authorName){
  //     //     this.author=this.edit_achievement[0].authorName
  //     // }
  // console.log('im inside mount in achieveedit comp')

  // // const payload2 = {
  // //           _id: this.edituser._id,
  // //         };

  // // await this.$store.dispatch("achievement/getAchievementById", payload2);

  // // console.log(this.edit_achievement[0].authorName)

  // // this.author=this.edit_achievement[0].authorName
  // // this.cname=this.edit_achievement[0].courseName
  // // this.expiredate=this.edit_achievement[0].expiredDate
  // // this.issuedate=this.edit_achievement[0].issuedDate
  // // this.file=this.edit_achievement[0].file

  //   this.CNAME()
  //   },
  //  created(){
  //        this.cname=this.edituser.cname
  //     // console.log('creadted');
  //     //     if(this.edit_achievement[0].authorName){
  //     //     this.author=this.edit_achievement[0].authorName
  //     // }

  //   },

  watch: {
    isOpenLocal(isOpenLocal, oldopen) {
      if (isOpenLocal == true) {
        this.getAchievementById();
      }
    },
  },
};
</script>

<style>
.formborder {
  border: 2px solid #830c81;
  border-radius: 0.375rem;
  width: 100% !important;
}
</style>
